// return  config values for production when local NAPI service is not available
const prodConfig = {
	BUGSNAG_CLIENT_ID: 'a364f63ff6217eb6e957d3d82cb76ecc', // NAPIC BUGSNAG
	FULLSTORY_ORG_ID: '9WAVH',
	LAUNCHDARKLY_CLIENT_ID: '648753e35f34ab13ac68b587',
	DATADOG_RUM_APP_ID: '5f19919e-294d-4af3-8179-ad5e4b33a2c2',
	DATADOG_RUM_CLIENT_TOKEN: 'pub74c9d253cd6c7ea9e0a02223d0d0d91a',
	AUTODESK_PROFILE_ACCOUNT: 'https://profile.autodesk.com/personalinfo',
	LEARN_MORE:
		'https://help.autodesk.com/view/BUILD/ENU/?contextId=Members_ACC_Profile',
	REGION: 'US', // we can probably remove this later and use exo solution to get region dynamic.
	REMOTE_ASSETS_URL:
		'https://assets.acc-network-api-components.acc.autodesk.com',
}

export default prodConfig
